import React, { useState } from "react"
import { MdArrowBack, MdDone, MdDoneAll, MdSend } from "react-icons/md"
import { auth } from "../firebase"
// import Icon from "react-native-vector-icons/Feather"
// import IconV from "react-native-vector-icons/MaterialIcons"
import getMessages, { sendMessage } from "../functions/chat"

const width = window.innerWidth
const height = window.innerHeight

const styles = {
    header: {
        height: 55,
        display: "flex",
        alignItems: "center",
        flexDirection:"row",
        padding: "0 15px",
        backgroundColor: "#F00",
        position: "absolute",
        top: 0,
        width: width - 30,
        borderRadius: "10px 10px 0 0"
    },
    inputWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "10px 0",
        justifyContent: "space-around",
        position: "absolute",
        bottom: 0,
        backgroundColor: "#141414",
        width
    },
    input: {
        backgroundColor: "#fff",
        padding: "12px 15px",
        borderRadius: 25,
        width: width - 110,
        fontSize: 17,
        outline: "none",
        border: "none"
    },
    sendButton: {
        backgroundColor: "red",
        width: 45,
        height: 45,
        borderRadius: 50,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    title: {
        fontSize: 15,
        color: "#FFF",
        margin: "0 10px"
    },
    sender: {
        display: "flex",
        alignSelf: "flex-end",
        margin: 5,
        backgroundColor: "#FFF",
        color: "#000",
        borderRadius: 10,
        padding: "10px 15px",
        fontSize: 14,
        maxWidth: width * 0.7,
        marginRight: width * 0.02
    },
    receipt: {
        margin: 5,
        backgroundColor: "#F00",
        color: "#FFF",
        borderRadius: 10,
        padding: "10px 15px",
        fontSize: 14,
        maxWidth: width * 0.7,
        marginLeft: width * 0.02
    }
}

function FlatList({ data, keyExtractor, renderItem: Component }) {
    return data.map(item => <Component key={keyExtractor(item)} item={item} />)
}

export default function Chat({ navigation }) {

    const messages = getMessages()
    const [message, setMessage] = useState("")

    return (
        <div style={{ width, height, backgroundColor: "#141414" }}>
            <div style={styles.header}>
                <div onClick={navigation.goBack} >
                    <MdArrowBack size={22} color="#FFF" />
                </div>
                <p style={styles.title}>Dr Makhwanya Private Practice</p>
            </div>
            <div style={{ width, height }} >
                <div style={{ height: 70, width }} />
                <FlatList 
                    data={messages}
                    keyExtractor={item => item._id}
                    inverted
                    renderItem={({item}) => {

                        const sender = item.sender === auth?.currentUser?.uid
                        
                        return (
                            <div style={{ 
                                display: "flex",
                                flexDirection: "row", 
                                alignItems: "center",
                                justifyContent: sender ? "flex-end" : "flex-start",
                                margin: !sender ? `0 0 ${width * 0.01}px 0` : `0 ${width * 0.01} 0 auto`,
                            }}>
                                <p style={sender ? styles.sender : styles.receipt}>
                                    {item.message}
                                </p>
                                {sender && (
                                    item.read ? <MdDoneAll size={20} color="red" /> : <MdDone size={20} color="gray" />
                                ) }
                            </div>
                    )}}
                /> 
                <div style={{ height: 70, width }} />
            </div>
            <div style={styles.inputWrapper}>
                <div style={{ maxHeight: 100, overflowY: "auto" }}>
                    <input 
                        onChange={({ target: { value }}) => setMessage(value)} 
                        value={message} 
                        style={styles.input} 
                        placeholder="Type A Message"
                    />
                </div>
                <div onClick={() => {
                    sendMessage(message)
                    setMessage("")
                }} style={styles.sendButton}>
                    <MdSend size={25} color="#fff" />
                </div>
            </div>
        </div>
    )
}
